var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTaskInProgress = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34548 4.34548C5.84727 2.8437 7.88413 2 10.008 2V18.016C7.88413 18.016 5.84727 17.1723 4.34548 15.6705C2.8437 14.1687 2 12.1318 2 10.008C2 7.88413 2.8437 5.84727 4.34548 4.34548ZM14.4491 4.7795L15.1842 3.90348C14.4741 3.30246 13.6646 2.82999 12.792 2.50735L12.401 3.58133C13.1482 3.85851 13.8413 4.26398 14.4491 4.7795ZM16.7633 8.86424L17.8888 8.62812C17.7306 7.71417 17.4136 6.83498 16.952 6.03039L15.9617 6.57625C16.357 7.28782 16.6281 8.06157 16.7633 8.86424ZM12.792 17.5087L12.401 16.4347C13.1482 16.1575 13.8413 15.7521 14.4491 15.2366L15.1842 16.1126C14.4741 16.7136 13.6646 17.1861 12.792 17.5087ZM15.9617 13.4404L16.952 14.0124C17.4138 13.1986 17.7309 12.3108 17.8891 11.3885L16.7633 11.1901C16.628 11.9808 16.3568 12.7422 15.9617 13.4404Z",
    fill: "#F1BF33"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTaskInProgress);
export default ForwardRef;